import React, { useRef, useState, useEffect, lazy, Suspense } from 'react';
import { MenuItems } from './liensMenu';
import { Link } from 'gatsby';
import { Tagline } from '../../../svgIcons/tagline'

const Menu = () => {
  const [navbarOpen, setNavbarOpen] = useState(false)
  const TrackMenu = useRef(null);
  const liens = MenuItems
  const NavBarOrdi = lazy(() => import('./ordinateur/nav'));
  const NavBarMobile = lazy(() => import('./mobile/nav'));
  const [isMobile, setIsMobile] = useState(true)
  useEffect(() => {
    if (window.innerWidth >= 768) {
      setIsMobile(false)
    }
    if (TrackMenu && TrackMenu.current) {
      //Nous allons récupérer les éléments :
      /* La barre de menu */
      const menu = document.querySelector('#menu');
      /* Le logo */
      const logoPath = document.querySelector('.logo-path');
      /* La tagline */
      const tagline = document.querySelector('#tagline-menu');
      //La fonction qui va gérer les changements lors du scroll
      const handleScroll = () => {
        /* le scrolling du user en Px */
        var scrolling = document.documentElement.scrollTop + document.body.scrollTop;
        /* On fixe une limite de scroll depuis le haut de la page */
        const limit = 250;
        if (scrolling < 300) {
          var progress = (scrolling / limit)
          // L'objectif va être de jouer sur la transition entre le logo écrit et la tagline
          //La tagline va progressivement apparaître via opacity et le logo va se réduire

          /* On va réduire progressivement la taille du logo de 5 pixels */
          var reduceValue = 5 * progress
          /* On va réduire progressivement le padding du menu jusqu'à 0, le padding initial étant de 10px */
          var reducePaddingValue = 10 * progress
          /* La valeur width initiale du logo est de 40px */
          var logoWidth = 40 - reduceValue
          var padding = 10 - reducePaddingValue
          var opacityValue = ''
          if (progress > 1) {
            opacityValue = 1
          } else {
            opacityValue = progress
          }
          tagline.style.opacity = opacityValue
          logoPath.style.width = logoWidth
          menu.style.paddingTop = 'md:' + padding + 'px'
        }
        if (window.pageYOffset !== 0) {
          menu.classList.add("text-slate-800");
          menu.classList.add("shadow-md");
          menu.classList.add("light-bckgrd");
          logoPath.classList.add("white-path");
          logoPath.setAttribute("viewBox", "0 0 841.9 777.2");
          menu.classList.remove("pt-2.5");
        }
        else {
          menu.classList.remove("light-bckgrd", "shadow-md");
          menu.classList.add("pt-2.5");
          logoPath.classList.remove("white-path");
          logoPath.setAttribute("viewBox", "0 0 841.9 1077.2");
        }
      };
      handleScroll()
      document.addEventListener('scroll', handleScroll, { passive: true });
      return () => {
        // clean up the event handler when the component unmounts
        document.removeEventListener('scroll', handleScroll);
      };
    }
  }, [TrackMenu]);

  return (
    <div ref={TrackMenu} id="menu" className={`header sticky top-0 strong-bckgd pt-2.5 z-50  ${navbarOpen === true ? 'h-screen shadow-md light-bckgrd' : ''}`}>
      <div className="container mx-auto w-full relative text-center md:flex md:items-center md:justify-between">
        <div className=' py-2 md:basis-1/12 md:py-0'>
          {TrackMenu ?
            <>
              <Link aria-label='Homepage' to='/'>
                <svg className="logo-path mx-auto w-10" enableBackground="new 0 0 841.9 1077.2" version="1.1" viewBox="0 0 841.9 1077.2">
                  <path d="m544.3 319.1c-90.6-90-180.7-180.5-271.3-270.4-34.8-34.6-76.7-43.7-121.4-24.4-43.2 18.7-65.1 54.5-65.3 101.9-0.3 55.8 0.8 111.6 0.8 167.4 0 90.2-2.4 180.6 0.1 270.7 1.8 63.3 49.7 107.5 109.8 98.7 80.7 0.3-55.7-0.5 62.5-0.1 16.8 0.1 26.4-8.1 28.3-23.9 2-17.7-8.9-33.2-25.4-34.7-18.5-1.7-22.2-0.7-34.1-0.2 11.6-0.1 19.3-0.1-0.1 0-3.5 0.1-7.6 0.2-13 0.2-20.8 0-6.8-0.1 7.2-0.2-10.5 0-26.3 0.1-49.3 0.2-24.4-10.7-32.8-31.1-32.6-57.3 0.6-69.1 0.2-138.1 0.2-207.1h-0.1c0-68.1 0.4-136.2-0.2-204.2-0.3-27.2 6.2-49.8 33.2-61.3 27.2-11.5 47.8 0 66.9 19.3 71.6 72.2 143.7 144 215.7 215.9 17.1 17 33.8 34.6 52.2 50.1 12.7 10.6 27.9 10.1 39-3.9 10.1-12.5 8.8-24.9-3.1-36.7z" />
                  <path d="m228.4 604h-5.9 5.9z" />
                  <path d="m735.6 114c-1.5-54.4-37.3-94.8-85.6-99.2h-0.3c-5.4-0.5-11-0.5-16.7-0.1-94.4-0.4 52.1 0.4-69.1 0.1-16.8 0-26.5 8.1-28.3 23.9-2 17.7 8.9 33.2 25.4 34.7 18.6 1.7 22.2 0.7 34.2 0.2-11.7 0.1-19.5 0.1 0.1 0 3.4-0.1 7.6-0.2 12.9-0.2 20.6 0 7.1 0.1-6.7 0.2 10.1 0 25.1-0.1 46.6-0.2l0.1 0.2c25.6 10.5 34.3 31.2 34.1 58-0.6 69-0.2 138.1-0.2 207.1h0.1c0 68.1-0.4 136.1 0.2 204.2 0.3 27.2-6.2 49.8-33.2 61.2-27.2 11.6-47.8 0-66.9-19.3-71.6-72.2-143.7-144-215.7-215.9-17.1-17-33.8-34.6-52.3-50.1-12.6-10.6-27.9-10.1-39 3.8-9.9 12.5-8.6 24.8 3.3 36.7 90.6 90 180.7 180.5 271.3 270.4 34.8 34.5 76.7 43.7 121.3 24.3 43.2-18.7 65.1-54.5 65.3-101.9 0.2-55.8-0.8-111.6-0.8-167.4 0-90.2 2.4-180.5-0.1-270.7z" />
                  <path d="m595.1 73.5h6.3-6.3c0.1 0 0 0 0 0z" />
                  <path d="m20.5 862.2c0-5.9 2.7-10.6 8.8-10.6 6.2 0 8.8 4.7 8.8 10.6v12.1h0.6c9.1-13.8 23.8-24.4 48-24.4 28 0 54.5 16.2 54.5 51.8v89.8c0 5.9-2.7 10.6-8.8 10.6-6.2 0-8.8-4.7-8.8-10.6v-87.4c0-26.2-16.5-38.9-36.8-38.9-29.1 0-48.6 20-48.6 56.5v69.8c0 5.9-2.6 10.6-8.8 10.6s-8.8-4.7-8.8-10.6l-0.1-129.3z" />
                  <path d="M132.3,1006c-7.8,0-12.8-5.7-12.8-14.6v-87.4c0-21.8-12.3-34.9-32.8-34.9c-27.9,0-44.6,19.6-44.6,52.5v69.8 c0,8.9-5,14.6-12.8,14.6c-7.8,0-12.8-5.7-12.8-14.6V862.2c0-8.9,5-14.6,12.8-14.6c7.8,0,12.8,5.7,12.8,14.6v1.3 c11.1-11.7,26-17.7,44.6-17.7c29.1,0,58.5,17.3,58.5,55.8v89.8C145.2,1000.2,140.1,1006,132.3,1006z" />
                  <path d="M240.9,847.6h-46.2c-8.4,0-14,4.9-14,12.2c0,7.6,5.4,12.2,14,12.2h47.4c19.9,0,26,5.7,26,24.3v3.1h-6 c-30.7,0-54.5,5.3-70.7,15.7c-15.7,10.1-24,25.1-24,43.4c0,17.1,6.1,29.9,18,38c10.2,6.9,24.9,10.4,43.7,10.4 c16.9,0,30.6-3.6,40.8-10.7c1.1,4.7,4,9,11.6,9c12.3,0,12.3-11,12.3-17v-93C293.8,862.2,277.5,847.6,240.9,847.6z M262.3,973.8 c-6.3,6.5-17.5,9.7-33.4,9.7c-25.5,0-34.6-12.2-34.6-23.7c0-15.1,9.2-25.3,28.2-31.4c14.9-4.7,32.5-5.7,45.6-5.8v33.7l0,0.1 C268.4,963.7,266.4,969.5,262.3,973.8z" />
                  <path d="M329.8,862.2c0-10,2.3-12.4,35.3-12.4c78.3,0,96.5,54.7,96.5,85.7c0,39.7-26.5,65.6-72.4,65.6h-41.8v47.7 c0,5.3-2.6,10-8.8,10c-6.2,0-8.8-4.7-8.8-10.6V862.2z M347.5,984.6H384c38.9,0,58.9-15.9,58.9-52.1c0-33.3-28.3-66.2-72.4-66.2h-23 V984.6z" />
                  <path d="M338.6,1062.8c-7.8,0-12.8-5.7-12.8-14.6v-186c0-14.7,8-16.4,39.3-16.4c35.8,0,63,11,80.7,32.7 c17.9,21.9,19.8,47.1,19.8,57c0,42.9-29.3,69.6-76.4,69.6h-37.8v43.7C351.5,1057.1,346.3,1062.8,338.6,1062.8z M351.5,980.6H384 c18.9,0,32.4-3.8,41.4-11.5c9.1-7.8,13.5-19.8,13.5-36.6c0-15.6-6.7-31.2-18.5-42.7c-12.8-12.6-30.5-19.5-50-19.5h-19V980.6z" />
                  <path d="M548.8,1005.1h-55c-8.6,0-14-4.7-14-12.2c0-7.3,5.6-12.2,14-12.2h64.5c22.2,0,30.1-17.1,30.1-33.1 c0-19.4-18.5-22.9-48.9-26.4c-26.5-3-56.5-6.5-56.5-34.8c0-22.8,16.2-38.7,39.3-38.7h65c8.2,0,13.7,4.9,13.7,12.2 c0,7.4-5.4,12.2-13.7,12.2h-65.6c-6.3,0-13.1,4.5-13.1,11.9c0,8.3,12.7,10.2,33.5,12.3c30.3,3.1,71.8,7.4,71.8,53 C614,984.7,590.2,1005.1,548.8,1005.1z" />
                  <path d="M662.1,991.4c0,5.9-2.7,10.6-8.8,10.6c-6.2,0-8.8-4.7-8.8-10.6V861.3c0-5.9,2.6-10.6,8.8-10.6 c6.2,0,8.8,4.7,8.8,10.6V991.4z" />
                  <path d="M653.3,1006c-7.8,0-12.8-5.7-12.8-14.6V861.3c0-8.9,5-14.6,12.8-14.6c7.8,0,12.8,5.7,12.8,14.6v130.1 C666.1,1000.2,661.1,1006,653.3,1006z" />
                  <path d="M761.3,1005.1h-55c-8.6,0-14-4.7-14-12.2c0-7.3,5.6-12.2,14-12.2h64.5c22.2,0,30.2-17.1,30.2-33.1 c0-19.4-18.5-22.9-48.9-26.4c-26.5-3-56.5-6.5-56.5-34.8c0-22.8,16.2-38.7,39.3-38.7h65c8.2,0,13.7,4.9,13.7,12.2 c0,7.4-5.4,12.2-13.7,12.2h-65.6c-6.3,0-13.1,4.5-13.1,11.9c0,8.3,12.7,10.2,33.5,12.3c30.3,3.1,71.8,7.4,71.8,53 C826.5,984.7,802.7,1005.1,761.3,1005.1z" />
                </svg>
              </Link>
              <Tagline />
            </>
            : ''
          }
        </div>
        <Suspense fallback="Loading">
          {!isMobile
            ? <NavBarOrdi liens={liens} />
            : 
              navbarOpen === true 
              ? <NavBarMobile liens={liens} /> 
              : ''
            }
        </Suspense>
        {
          TrackMenu ?
            <svg
              xmlns="<http://www.w3.org/2000/svg>"
              id="menu-button"
              className="h-6 w-6 cursor-pointer md:hidden block absolute top-2.5 right-0"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              onClick={() => setNavbarOpen(!navbarOpen)}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
            : ''
        }
      </div>
    </div>
  )
}

export default Menu
